import { Text } from '@blueprintjs/core'
import { usePage } from '@inertiajs/react'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import { ClientLocaleNS } from 'lib/constants/locales'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ClientPageProps } from 'types'

type TProps = {}

type TPageProps = {
  email_confirmed: boolean
} & ClientPageProps

const EmailConfirmPageContent: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.SignUpPage)
  const {
    props: { email_confirmed },
  } = usePage<TPageProps>()
  return (
    <div className="flex flex-1">
      <ResponsiveBlock>
        <div className="flex flex-col flex-1 justify-center items-center text-center">
          <Text tagName="span" className="font-body---24px text-palette-white">
            {t(email_confirmed ? 'email_confirmed' : 'invalid_email_token')}
          </Text>
        </div>
      </ResponsiveBlock>
    </div>
  )
}

export { EmailConfirmPageContent }
